import { useIntl } from '@capsicum/common';
import { BaseCheckboxInput as Checkbox } from '@capsicum/common-web';
import { useAmlAccountCreationReasons } from '@capsicum/features/regulations/shared';

import * as S from './AmlQuestionnaire.styled';

export const AccountCreationReasons = () => {
	const { $t } = useIntl();
	const { choiceHandler, options } = useAmlAccountCreationReasons();

	return (
		<S.Wrapper>
			<S.Question>{$t('amlQuestionnaire.firstStep.question')}</S.Question>
			{options.map((option, index) => (
				<Checkbox
					key={index}
					testID={`aml-questionnaire-account-creation-reasons-checkbox${index + 1}`}
					onChange={e => choiceHandler(e, option.value)}
				>
					<S.CheckboxText>{option.text}</S.CheckboxText>
				</Checkbox>
			))}
		</S.Wrapper>
	);
};
